module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter2"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block7"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TOC"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps-rw"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps-rw"
  }, [_vm._v("WO")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p129"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/leftswoosh_rev1_svg_online.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/rightswoosh_rev1_svg_online.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p143"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("M")]), _vm._v("ariah Winslow pressed her ear against the study door, but she could hear nothing of the conversation her father was having with her sister. Or rather, the scolding he was undoubtedly unleashing upon poor Evelyn. With a sigh, she sank onto the chair in the hall to wait her turn.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p144"
    }
  }, [_vm._v("Another morning, another chastisement from Papa…as predictable as the tide on the Thames. Lately, it seemed as if they spent every morning this way, with Papa demanding that she and Evelyn act like proper young ladies and them promising to behave, while wholly unrepentant for their societal sins.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p145"
    }
  }, [_vm._v("This time, however, she feared that she and Evie might have gone too far.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p146"
    }
  }, [_vm._v("Certainly, racing Hugh Whitby’s phaeton down St James’s Street seemed like a good idea at the time. Something daring and bold, Evie had assured her, that would get their hearts pumping and destroy the boredom of a winter’s afternoon. "), _c('i', [_vm._v("Something to make us feel alive")]), _vm._v(", Evie had pleaded. Mariah dearly loved her sister and found it difficult to deny Evie anything. Not when she knew how much their mother’s death still affected her, even fifteen years later. And certainly not with that adventurous spirit of hers that was simply contagious. So how could she have refused? After all, if she hadn’t joined in, God only knew the trouble her younger sister might have gotten into on her own. So she’d conceded, and they’d launched into the madcap adventure that had proven to be as exhilarating as Evie predicted.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p147"
    }
  }, [_vm._v("Yet Mariah would also never forgive herself if Evelyn were ever seriously punished by Papa for doing something in which Mariah had taken part.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p148"
    }
  }, [_vm._v("Pressing the edge of propriety was one thing, but if the two of them ever went too far, there could be dire consequences. Evie might be sent away, most likely back to Miss Pettigrew’s School for the Education and Refinement of Young Ladies, which seemed populated more by scandalous daughters whose families wanted them exiled all the way to Cornwall than by young ladies seeking refinement. How would Mariah bear to remain here in London without her sister, especially when Papa barely spent any time with her lately, except to chastise her for her unladylike behavior?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p149"
    }
  }, [_vm._v("It hadn’t always been like that. There was a time when Mariah had been his constant shadow, following after him on the wharves and spending more time at the shipping offices than at home. But then he’d sent her away to school, and when she returned, everything had changed. While she still longed to be at his side, Papa was equally determined that she would lead the life of a fine lady. And reputable ladies didn’t work in business.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p150"
    }
  }, [_vm._v("Which was why Mariah didn’t care a fig about becoming a lady. What she wanted—what she’d "), _c('i', [_vm._v("always")]), _vm._v(" wanted—was a true partnership in Winslow Shipping. And she was determined to have just that.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p151"
    }
  }, [_vm._v("The study door opened, and Evelyn slipped into the hallway, looking as unrepentant as ever.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p152"
    }
  }, [_vm._v("Mariah darted to her feet. “Is he terribly angry?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p153"
    }
  }, [_vm._v("“I should begin packing my things for Miss Pettigrew’s,” Evie answered matter-of-factly, repeating Papa’s words.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p154"
    }
  }, [_vm._v("A knowing smile tugged at Mariah’s lips. “So the usual threat, then?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p155"
    }
  }, [_vm._v("With a frown of distraction, Evie nodded. Then she captured Mariah’s hands in both of hers, with worry darkening her face. “I’m so sorry, Mariah! He blames you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p156"
    }
  }, [_vm._v("Of course he did. But he wasn’t completely wrong. As the older sister, wasn’t it her responsibility to keep Evie from harm?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p157"
    }
  }, [_vm._v("Evie’s bottom lip quivered with guilt. “He’s talking about punishing you this time. "), _c('i', [_vm._v("Seriously")]), _vm._v(" punishing you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p158"
    }
  }, [_vm._v("“It’s all right.” She squeezed Evie’s hands reassuringly. “What can he do to me? I’m too old to be tossed over his knee and spanked.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p159"
    }
  }, [_vm._v("Most likely, he would forbid her to spend any time during the next fortnight at the Gatewell School in St Katharine’s, where she donated the better share of her time and allowance to keeping the doors open, instructors in the classrooms, and food in the children’s hungry bellies. Oh, how she loved St Katharine’s! It was the same parish where her mother had been born and raised. The same narrow, winding streets where Mariah had often walked hand in hand with her as a little girl. Now, every time Mariah walked through those streets, she felt connected to her mother. Mama was so distant now that Mariah could no longer remember what she’d looked like, knowing her beautiful features only from the portrait in Papa’s study. But in St Katharine’s, she could remember her mother as clearly as if she still walked beside her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p160"
    }
  }, [_vm._v("She wouldn’t like being kept away from the school, certainly, but it would be a fitting punishment, both for her and for Whitby, who assisted her at the school and would miss having her help. After all, he was complicit for letting them borrow his phaeton in the first place.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p161"
    }
  }, [_vm._v("“Mariah,” her father called out, “I will see you now.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p162"
    }
  }, [_vm._v("“Good luck!” Evie placed a kiss to her cheek, then hurried away to her room as she did after every one of these morning talks with their father. Ostensibly to pack for Cornwall, only to be reprieved by dinnertime when Papa always changed his mind.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p163"
    }
  }, [_vm._v("Drawing in a deep breath, Mariah walked into the study and stopped in front of her father’s large desk. She contritely folded her hands in front of her and awaited the ritual tongue-lashing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p164"
    }
  }, [_vm._v("“This time, my dear, you have gone too far.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p165"
    }
  }, [_vm._v("She resisted the urge to roll her eyes.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p166"
    }
  }, [_vm._v("He wouldn’t be scolding her like this if she were a man. No, he’d have been crowing with pride that his son possessed the skills to match any of the best drivers among the gentry. On the other hand, if he’d treated her with the same respect and pride that he would have treated a son, she would have been too busy with the business to look for ways to disrupt a dull afternoon in the first place.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p167"
    }
  }, [_vm._v("She swallowed down the bitter taste of frustration. At twenty-five, she should have already been a partner in the company, fulfilling the dream she’d wanted since she was a little girl. To have a serious role in running the family business. To participate in the merchant trade that was such a large part of her father’s world and that still connected her to her late mother. Instead, he saw her as nothing more than a young miss to be dressed up in furs and silks like a doll, who should be content wasting away her days at silly teas and boring balls.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p168"
    }
  }, [_vm._v("But Mariah wasn’t like that. Had never been. One good look should have told him that.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p169"
    }
  }, [_vm._v("These days, however, Papa never truly "), _c('i', [_vm._v("saw")]), _vm._v(" her at all. Unless she was standing in front of him, being scolded. Like now. But instead of gaining his attention, he saw her behavior as simply another act of rebellion.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p170"
    }
  }, [_vm._v("He shook his head. “A phaeton on St James’s Street.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p171"
    }
  }, [_vm._v("“I drove that team well,” she countered. “You cannot deny that.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p172"
    }
  }, [_vm._v("“Yes, you drove well.” For a moment, she thought she saw a flicker of pride in his eyes. “But you are not a driver at the Ealing Races. You are a young lady from a respectable family—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p173"
    }
  }, [_vm._v("Her chest fell. No, not a flicker of pride after all.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p174"
    }
  }, [_vm._v("“—one who scandalously flaunted herself by racing down St James’s Street—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p175"
    }
  }, [_vm._v("“I did not "), _c('i', [_vm._v("flaunt")]), _vm._v(" myself,” she corrected firmly but quietly. Heavens! He made her sound like an actress strutting the boards at Covent Garden.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p176"
    }
  }, [_vm._v("“—risking both her neck and her sister’s, in addition to ruining their reputations.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p177"
    }
  }, [_vm._v("“Our reputations are not ruined.” "), _c('i', [_vm._v("That")]), _vm._v(" was one thing about which she was always careful. No matter how bold her antics, she always danced the fine line that separated acts for idle rumors from acts of ruination. Oh, she’d let the fops and hens of the so-called quality gossip about her behind her back all they wanted to, as if she didn’t know that they already did just that. As if she didn’t know that they’d nicknamed her the Hellion. She couldn’t care less what those busybodies thought of her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p178"
    }
  }, [_vm._v("But ruining her reputation meant possibly ruining the business’s reputation, and she would "), _c('i', [_vm._v("never")]), _vm._v(" do anything to harm Winslow Shipping. She loved the company as much as her father did, and what she desired more than anything was to work side by side with him in growing the business for the next generation of Winslows who would continue the company that her grandfather had started. She held no delusions about running the business herself. As a woman, she’d never be able to do that. But it was certainly within her reach to be a partner, one who oversaw day-to-day responsibilities. And then it would truly be a family business in every way.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p179"
    }
  }, [_c('i', [_vm._v("If")]), _vm._v(" Papa would ever let her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p180"
    }
  }, [_vm._v("“If you keep behaving like some wild creature without any understanding of her position,” Papa continued, exasperation heavy in his voice, “how do you ever expect to find a respectable husband?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p181"
    }
  }, [_vm._v("She bit back the urge to answer that she hoped to find a "), _c('i', [_vm._v("dis")]), _vm._v("respectable husband, knowing a comment like that would certainly get her sent back to Miss Pettigrew’s, right beside Evie.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p182"
    }
  }, [_vm._v("“How do you expect to receive any invitations for this upcoming season if you behave like this?” he demanded in a tone clearly implying that he did not want an answer. “A lady of quality would never invite someone who cannot control herself to her soiree.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p183"
    }
  }, [_vm._v("Oh, the devil take society invitations! The very "), _c('i', [_vm._v("last")]), _vm._v(" place Mariah wanted to be was at some stuffy, boring ball. If society cut her completely, what would she care…or notice? After all, it wasn’t as if the quality was flooding the front foyer with calling cards and invitations in the first place. Not when they regarded the Winslows as nothing but upstart cits infringing on their hallowed aristocratic ranks. While they couldn’t ignore the importance of the company or her family’s wealth, they could certainly ignore "), _c('i', [_vm._v("her")]), _vm._v(". And did.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p184"
    }
  }, [_vm._v("Yet this was the part of Papa’s speech that Mariah knew by heart, the same one it seemed lately he’d delivered at least once per sennight and more frequently as the new season approached. Another season in which he hoped she would finally venture into the uncharted waters of society and make her mark, ideally snatching up a fine husband in the process. Mariah couldn’t have cared less. But this division between them seemed to be growing wider as the season drew nearer.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p185"
    }
  }, [_vm._v("This hadn’t been an issue before she was sent to Miss Pettigrew’s, where she’d received a fine education…"), _c('i', [_vm._v("if")]), _vm._v(" all she wanted to know was how to host dinner parties, paint watercolors, and play the pianoforte. So she’d taken it upon herself to carve out a real education through tutors secretly paid to ignore whatever frivolous lesson had been planned that day and teach her useful skills instead. The result was an education that more than prepared her for success in business. And a decided lack of talent at the pianoforte.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p186"
    }
  }, [_vm._v("But Papa refused to entertain the idea of her working with him. All he wanted to know was how she planned to spend her season, when she would marry and give him grandchildren. Every time she arrived at the office to surprise him, to throw herself into work and show him how capable she was, he promptly told her that the docks were no place for a lady and sent her home.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p187"
    }
  }, [_vm._v("So last fall, she’d set out to prove to her father that she was far more than just some mindless miss. To finally gain his attention as something other than someone to be molded into a perfect society lady. To show him how important the business was to her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p188"
    }
  }, [_vm._v("And so far…")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p189"
    }
  }, [_vm._v("“Mariah, you are embarrassing yourself and this family.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p190"
    }
  }, [_vm._v("It wasn’t going well. At this rate, he might never offer her the partnership she dreamt of.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p191"
    }
  }, [_vm._v("Yet he hadn’t offered one to anyone outside the family, either. She took hope in that. Because perhaps that meant he understood that the best person to guide Winslow Shipping and Trade was a Winslow. To Mariah, the company was so much more than a business. It was her heart and soul, and one of the few connections she had left to that happy time before her mother’s death. Surely, Papa was coming around to realizing that.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p192"
    }
  }, [_vm._v("If not…well, then she’d simply wear him down until he surrendered. Siege warfare worked with medieval castles, after all. And she couldn’t imagine a more medieval relic than Henry Winslow.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p193"
    }
  }, [_vm._v("“So I have decided to make some changes.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p194"
    }
  }, [_vm._v("Mariah’s gaze snapped to his. "), _c('i', [_vm._v("That")]), _vm._v(" was different.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p195"
    }
  }, [_vm._v("Usually this was the part of the speech where he threatened to revoke her allowance, to force her to remain room-ridden for the next fortnight, to send her to a convent even though they were devoutly Church of England—")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p196"
    }
  }, [_vm._v("But this time, there were no empty threats. This time, he stared at her across his desk with the same glint in his eyes that shined whenever he faced down business adversaries.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p197"
    }
  }, [_vm._v("“I’ve been listening to you during the past few months,” he told her, “to your concerns about how the company needs new blood. How we need a new generation to keep us moving into the future.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p198"
    }
  }, [_vm._v("“You have?” Hope fluttered low in her belly. She could scarcely believe it!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p199"
    }
  }, [_vm._v("“And I’ve decided that you are right. Changes need to be made, ones which will benefit the company while also staying true to what your mother wanted.” He started for the door. “Come with me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p200"
    }
  }, [_vm._v("He stalked from the room in long strides. She fell into step beside him, yet she felt as if she were flying! Her feet barely touched the Persian rug beneath her in her joy to finally—"), _c('i', [_vm._v("finally!")]), _vm._v("—have this opportunity.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p201"
    }
  }, [_vm._v("“I have so many wonderful ideas we can discuss,” she rushed out, barely able to keep her breath beneath the overwhelming excitement pulsing through her. The same breathless joy as racing the phaeton—oh no, so much better!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p202"
    }
  }, [_vm._v("“Of course.” He dismissed her comment with a wave of his hand as they ascended the marble stairs. “First, however, there is a business associate I want you to meet.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p203"
    }
  }, [_vm._v("“Oh?” She puzzled as she followed him down the hall to the drawing room. “Who?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p204"
    }
  }, [_vm._v("But heavens, she didn’t care! At that moment, she didn’t want to meet anyone. Not when her chest was bursting with happiness. Instead, she wanted to skip and dance all the way to the company’s offices on Wapping High Street and—")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p205"
    }
  }, [_vm._v("Papa smiled proudly. “The man I’ve selected to be my partner.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p206"
    }
  }, [_vm._v("Mariah froze as the world plunged away beneath her. A partner? It couldn’t be. It simply "), _c('i', [_vm._v("couldn’t")]), _vm._v(" be true! A "), _c('i', [_vm._v("partner")]), _vm._v("…")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p207"
    }
  }, [_vm._v("But not her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p208"
    }
  }, [_vm._v("Stunned numb with disbelief, she was helpless to do anything more than stand in the doorway and watch her father stride across the room to greet the man waiting there. Her vision blurred with frustrated tears, and she forced herself to breathe as the waking nightmare crashed over her, as the numbness slowly gave way to piercing desolation. And grief. The same terrible grief that had overwhelmed her when her mother died.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p209"
    }
  }, [_vm._v("“Carlisle.” Her father enthusiastically shook the man’s hand, oblivious to the wretchedness he’d just unwittingly unleashed upon his daughter. “Glad to have you here.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p210"
    }
  }, [_vm._v("“My pleasure.” The man smiled as he released her father’s hand, stepping his legs apart and placing his fisted hand at the small of his back in a stance that was one of pure masculine command and ease. As if he had every right to be there, invading her life and stealing away her father’s attentions.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p211"
    }
  }, [_vm._v("Papa gestured for her to approach. “Let me introduce you to my daughter.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p212"
    }
  }, [_vm._v("But Mariah held her ground near the doorway, for once less from obstinacy and more because she didn’t have the strength to come forward without collapsing to the floor in sobs. Instead, she pressed her fist against her chest and willed herself to keep breathing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p213"
    }
  }, [_vm._v("“My eldest daughter, Mariah.” Her father frowned when she didn’t come sweeping across the room to greet their guest as any proper lady of the house would have. To graciously welcome this man into her home. And into a position with the company that should have been hers.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p214"
    }
  }, [_vm._v("She simply couldn’t do it. "), _c('i', [_vm._v("Never")]), _vm._v(" that.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p215"
    }
  }, [_vm._v("Blinking back her tears, she lifted her chin and silently stared at the stranger in cool disdain, even as her heart shattered like ice. She had too much pride to reveal how much this meeting devastated her. She "), _c('i', [_vm._v("was")]), _vm._v(" a Winslow, after all. Even if Papa had forgotten what that meant.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p216"
    }
  }, [_vm._v("“Mariah, this is Lord Robert Carlisle.” Her father slapped him on the shoulder. “The man who wants to partner with me to conquer the world’s shipping routes!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p217"
    }
  }, [_vm._v("A bitter taste formed in her mouth. "), _c('i', [_vm._v("Partner.")]), _vm._v(" On what merits? As her eyes raked over him, she saw nothing to believe that this man was any more qualified than she was. Moreover, "), _c('i', [_vm._v("she")]), _vm._v(" was a Winslow, entitled by blood and history to take her rightful place at her father’s side. While this man was nothing but an opportunistic interloper.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p218"
    }
  }, [_vm._v("Certainly, he was dressed well, sporting a dark blue cashmere jacket over a blue-and-cream-checkered satin waistcoat, a simply tied cream-colored cravat, and black trousers. The whole effect was one of careful consideration, she was sure, in an attempt to look as if he cared little for appearances while taking great pains to do so. She would have labeled him a dandy if not for the slight scuff to his boots, which showed that he’d actually ridden a horse to the house instead of being brought by carriage. Not a dandy, then, but certainly a Corinthian. One of those physically attractive and stylish young bucks over whom the old hens of the "), _c('i', [_vm._v("ton")]), _vm._v(" practically swooned whenever they flashed a charming smile.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p219"
    }
  }, [_vm._v("If there was one thing she’d come to know since she’d returned to London, however, it was that dandies, Corinthians, and bucks possessed very little intelligence among the lot of them. Certainly not the kind of business acumen that Winslow Shipping needed to flourish. Or the dedication that only a family member possessed.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p220"
    }
  }, [_vm._v("“Miss Winslow.” Carlisle crossed the room to her and bowed graciously. “A pleasure to meet you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p221"
    }
  }, [_c('i', [_vm._v("A pleasure.")]), _vm._v(" That was a lie if ever she’d heard one. She bobbed a stiff, shallow curtsy. Then purposefully ignored his courtesy title. “"), _c('i', [_vm._v("Mr.")]), _vm._v(" Carlisle.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p222"
    }
  }, [_vm._v("His eyes gleamed with amusement at that, as if he knew what dark thoughts about him lurked inside her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p223"
    }
  }, [_vm._v("“A businessman, are you?” she drawled coolly, affecting that same tone that Miss Pettigrew had used at school to keep the girls in line.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p224"
    }
  }, [_vm._v("“I’ve dabbled.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p225"
    }
  }, [_vm._v("“In shipping?” she pressed. Did the man even understand how the day-to-day operations of merchant trade worked? By the looks of him, she doubted he’d ever spent a single day laboring at the quayside or in warehouses. But "), _c('i', [_vm._v("she")]), _vm._v(" had, in those few precious weeks after she’d returned from school, before her father decided that a shipping company was no place for a lady.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p226"
    }
  }, [_vm._v("He modestly shrugged. “A bit.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p227"
    }
  }, [_vm._v("“Forgive me for doubting your "), _c('i', [_vm._v("bit")]), _vm._v(" of competence.” His eyes flared, and this time it wasn’t with amusement. “But it seems to me that of all the people my father could have chosen—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p228"
    }
  }, [_vm._v("“Mariah, give the man peace,” Papa ordered, a faint warning underlying his voice. And an even larger warning in the look he shot her. He turned to Carlisle and explained, “Mariah’s always been as protective as a bulldog of the company.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p229"
    }
  }, [_vm._v("Carlisle smiled at her, a charming grin she was certain he used to make his way through the world. And into women’s beds. Well, well—a Corinthian "), _c('i', [_vm._v("and")]), _vm._v(" a rake. In Winslow Shipping and Trade. Had Papa lost his mind?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p230"
    }
  }, [_vm._v("“Quite all right,” Carlisle asserted, but his eyes never strayed from Mariah. As if he realized that she considered him an adversary. “No offense taken.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p231"
    }
  }, [_vm._v("“Good,” Papa assured him, with an affectionate but frustrated smile at Mariah, “since you’re here precisely because of my daughter.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p232"
    }
  }, [_vm._v("Mariah gaped at that. How on earth could "), _c('i', [_vm._v("this")]), _vm._v(" be her fault? “I don’t understand.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p233"
    }
  }, [_vm._v("“Do you think I haven’t been listening to you?” He crossed to the tantalus in the corner of the room and removed a bottle of bourbon, then gestured toward Carlisle with it. “Been talking my ear off lately about what the business needs, how to leverage assets, where to create new trade routes…” He poured two glasses and handed one to Carlisle, keeping the other for himself. “That I should take on a partner.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p234"
    }
  }, [_vm._v("Not allowing humiliation to color her cheeks, Mariah folded her hands in front of her skirts and said quietly, “I meant me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p235"
    }
  }, [_c('i', [_vm._v("That")]), _vm._v(" drew Carlisle’s attention. His gaze snapped to her, narrowing hard for a beat.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p236"
    }
  }, [_vm._v("So did her father’s. For a fleeting moment, she thought she saw longing to do as she asked darken his face, followed by a flash of guilt.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p237"
    }
  }, [_vm._v("But then it was gone, and he was shaking his head. “A shipping company is not the place for a lady.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p238"
    }
  }, [_vm._v("“But it "), _c('i', [_vm._v("is")]), _vm._v(" the place for a Winslow,” she pressed quietly. “A family business should be run by family.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p239"
    }
  }, [_vm._v("“And a daughter’s duty to her family is to be a proper lady.” Papa was beginning to lose his patience. “Not a businessman.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p240"
    }
  }, [_vm._v("“The two do not have to be mutually exclusive,” she argued calmly, even as desperation knotted in her belly. She would "), _c('i', [_vm._v("not")]), _vm._v(" give up without a fight. “Family should run the company, not outsiders. It was what Grandfather wanted.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p241"
    }
  }, [_vm._v("“And I promised to raise you into a proper lady,” Papa countered. “It was what "), _c('i', [_vm._v("your mother")]), _vm._v(" wanted.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p242"
    }
  }, [_vm._v("His words sliced through her like a knife, cutting down to her heart, and she flinched, unable to answer.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p243"
    }
  }, [_vm._v("She turned her head away as the tears became dangerously close to falling and blinked furiously. She would "), _c('i', [_vm._v("never")]), _vm._v(" let Papa see this weakness in her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p244"
    }
  }, [_vm._v("“And that is exactly what I intend to do,” Papa promised. “What is best for you "), _c('i', [_vm._v("and")]), _vm._v(" for the company. Which is why I chose Carlisle.” Hiding his chagrin over the argument they’d just waged in front of the man, her father forced a smile and tapped his glass against Carlisle’s. The clink echoed through the silent room and teeth-jarringly rattled all the way down Mariah’s spine. “He’s the best man to do both. If he can prove himself.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p245"
    }
  }, [_c('i', [_vm._v("If.")]), _vm._v(" Hope sparked inside her. Then the partnership wasn’t final? “How?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p246"
    }
  }, [_vm._v("“By helping me with a new real estate venture I’m undertaking,” her father answered. He leveled his gaze on her, the intensity of it clearly stating that he would brook no argument. “And by giving you a proper season.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p247"
    }
  }, [_vm._v("She gasped at the unexpectedness—and sheer "), _c('i', [_vm._v("absurdity")]), _vm._v("—of that. “Pardon?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p248"
    }
  }, [_vm._v("“My mother is the Dowager Duchess of Trent,” Carlisle offered helpfully. “Your father thought you’d appreciate having her support this season.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p249"
    }
  }, [_vm._v("“Dowager duchess,” she repeated, not knowing how her numb lips were able to form the words. Her blood turned to ice, chilling her where she stood.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p250"
    }
  }, [_vm._v("So Lord Robert Carlisle was the son of a duke. Her father’s choice of him for a partner now made sense. Horrible, horrifying sense.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p251"
    }
  }, [_vm._v("“Mother enjoys helping young ladies with their seasons,” Carlisle continued with a smile, unaware that she’d figured out why "), _c('i', [_vm._v("him")]), _vm._v(". “Once I heard that you had no female relatives who could provide introductions, I was certain she’d be willing to assist you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p252"
    }
  }, [_vm._v("“I understand.” And she did. Perfectly. “How clever of you, Papa,” she said quietly, her eyes stinging with fresh tears. What mattered how deep—or shallow—Carlisle’s business mind if his connections stretched all the way into the Lords? And to a duke, no less. Her father was doing what was best for the family business, all right. By bringing in the family of a peer.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p253"
    }
  }, [_vm._v("“Two birds, one stone.” Her father gave her a satisfied look, as if he’d arrived at the answers to the world’s worst problems. All encapsulated right there in the dashing, golden form of Robert Carlisle. Her father lifted his glass to toast his solution. “Winslow Shipping gets young blood in a much-needed partner, and you get a proper London season at last.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p254"
    }
  }, [_vm._v("But she didn’t want a season. She wanted a role within the company, the chance to work side by side with her father. While this—this "), _c('i', [_vm._v("interloper")]), _vm._v(" came waltzing in with his sapphire-blue eyes and his duke of a brother to snatch her dream away.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p255"
    }
  }, [_vm._v("“To what end?” she asked quietly, too angry and frustrated to think clearly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p256"
    }
  }, [_vm._v("Her father blinked, as if the answer were obvious. “Marriage, of course.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p257"
    }
  }, [_vm._v("The world tilted beneath her, her breath dying in her throat. She reached for the back of a nearby chair to keep from losing her balance and falling to the floor.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p258"
    }
  }, [_vm._v("“You cannot be serious,” she whispered, unable in her surprise to find her voice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p259"
    }
  }, [_vm._v("“Very serious.” His face turned grim. “Your latest antics proved that I have not raised you properly, but I will no longer fail you as a father.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p260"
    }
  }, [_vm._v("She stared at him, stunned. Was that truly what he thought—that he’d "), _c('i', [_vm._v("failed")]), _vm._v(" her, when all she’d wanted was to capture his attention?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p261"
    }
  }, [_vm._v("“No,” she whispered, her heart aching with pained misunderstanding, “you "), _c('i', [_vm._v("haven’t")]), _vm._v(" failed. That wasn’t at all what—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p262"
    }
  }, [_vm._v("“And I will "), _c('i', [_vm._v("not")]), _vm._v(" fail your mother,” he added firmly. “She wanted her daughters to be the fine ladies that she could never be as the daughter of a sea captain. And that is exactly what I plan on giving her. Proper ladies with respectable husbands.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p263"
    }
  }, [_vm._v("“But "), _c('i', [_vm._v("I")]), _vm._v(" don’t want that,” she protested softly, her voice barely louder than a breath. Oh heavens, how much it hurt to defy her mother’s wishes! But Mama would also want her to be happy, and nothing in the world would bring her more happiness than being at her father’s side.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p264"
    }
  }, [_vm._v("“Carlisle will make that happen, both for you and your mother,” he continued, although Mariah couldn’t tell if he’d not heard her or if he’d heard and chosen to ignore her. “Arrangements have been made. It’s done now.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p265"
    }
  }, [_vm._v("“Papa, I will not participate in this,” she announced calmly, forcing her voice to remain steady even as her insides roiled with fury and betrayal. And more anguish than she wanted to acknowledge at openly defying him, when all she’d ever wanted was to make him proud of her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p266"
    }
  }, [_vm._v("“You do not have a choice.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p267"
    }
  }, [_vm._v("The sickening realization sank through her that this was the serious punishment Evie had warned her about. Her own special banishment, right into the hell of society.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p268"
    }
  }, [_vm._v("“You will involve yourself fully in the season—introductions, balls, breakfasts, soirees…"), _c('i', [_vm._v("all")]), _vm._v(" of it—whatever Carlisle and the duchess decide is best for you.” His gaze never wavered from hers. “Or I’ll cut off your allowance.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p269"
    }
  }, [_vm._v("The air rushed from her lungs. Her "), _c('i', [_vm._v("allowance")]), _vm._v(", and with it, all the help she provided to the Gatewell School and the children of St Katharine’s, children in need just like her mother had been. If Mariah lost the school, dear God, she’d lose her mother all over again!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p270"
    }
  }, [_vm._v("“You wouldn’t,” she whispered. Her hands clenched into helpless fists. The same powerless frustration swept over her that she remembered from when she’d been sent away to school, away from Evie and Papa and everything she loved.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p271"
    }
  }, [_vm._v("Her father said nothing but turned away and tossed back the rest of the bourbon with a gasping swallow. It was impossible to say if the flicker in his eyes came from guilt or resolve.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p272"
    }
  }, [_vm._v("Mariah stared at him, her chest burning so fiercely that each beat of her heart shattered through her like a hammer against glass. Oh, she’d certainly gotten his attention this time, but the result wasn’t at all what she’d hoped. Instead of allowing her to work at his side, he’d turned the distance between them into a chasm.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p273"
    }
  }, [_vm._v("And right in front of a stranger, no less. At least Carlisle had the decency to say nothing, staring down into his bourbon rather than watching them. Or gloating that he’d won.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p274"
    }
  }, [_vm._v("A soft scratch sounded at the door. “Excuse me, sir.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p275"
    }
  }, [_vm._v("Bentley, the butler who had run the household for her family as long as Mariah could remember, stepped into the room.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p276"
    }
  }, [_vm._v("“What is it?” Papa seemed grateful for the interruption.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p277"
    }
  }, [_vm._v("“There’s a caller at the door, sir.” Bentley glanced warily between all three of them, clearly sensing the tension that hung over the room as thick as London fog. “Mr. Ledford from the shipping office.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p278"
    }
  }, [_vm._v("“I’m afraid I have to see to this.” Papa set down his glass and gestured at the two of them. “I’ll be gone only a moment. You two need to discuss the upcoming season anyway. Why not get started immediately?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p279"
    }
  }, [_vm._v("As her father strode from the room, Mariah narrowed her eyes on Carlisle, turning all of her anger and frustration onto him. Then she smiled slowly, calculatingly…")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p280"
    }
  }, [_vm._v("Why not, indeed?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c818edb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s006-Chapter-002.vue
// module id = 75
// module chunks = 0